export default __webpack_public_path__ + "static/media/diplomaLogo.256d1806.jpg";